export const REVALIDATE_HASH = 'published'; // 'revalidate';

export const DEFAULT_PAGE_REVALIDATE = 86_400 as const; // 24 hours
export const DEFAULT_PAGE_REVALIDATE_THREE_DAYS = 259_200 as const;
export const DEFAULT_PAGE_REVALIDATE_FIVE_DAYS = 432_000 as const;
export const DEFAULT_PAGE_REVALIDATE_LONG = 864_000 as const; // 10 days
export const SITEMAP_REVALIDATE = 86_400 as const;

export const PAGE_REVALIDATE = {
  /** Standard revalidation period - 24 hours */
  default: 86_400,

  /** Extended revalidation period - 3 days */
  extended: 259_200,

  /** Long revalidation period - 5 days */
  medium: 432_000,

  /** Maximum revalidation period - 10 days */
  long: 864_000,

  /** Sitemap revalidation period - 24 hours */
  sitemap: 86_400,
} as const;
